import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/main.css';
import '@invested/design-tokens/dashboard-theme.css';
import { applyInvestedTheme, ConfirmDialogProvider, ToastProvider } from '@invested/ui';

if (typeof document !== 'undefined') {
  applyInvestedTheme('light');
}

const ProsjekthubShell: React.FC = () => (
  <ToastProvider>
    <ConfirmDialogProvider>
      <App />
    </ConfirmDialogProvider>
  </ToastProvider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ProsjekthubShell />
  </React.StrictMode>,
);
